import React, { createContext, useContext, useState } from 'react';

const AppContext = createContext();

export function AppProvider({ children }) {
  // 'demo' (default) | 'greenfield' | (future: 'epic', 'cerner', etc.)
  const [ehrContext, setEhrContext] = useState('demo');

  return (
    <AppContext.Provider value={{ ehrContext, setEhrContext }}>{children}</AppContext.Provider>
  );
}

export function useAppContext() {
  return useContext(AppContext);
}
